module.exports = __webpack_public_path__ + "media/components/home/preview-img-6e9ac4a5a3b7af2e8c90b269a03e4a66.png";